const blogArticles = Array.from(JSON.parse(document.querySelector('[data-blog-articles]').textContent));
const loadMoreButton = document.querySelector('.main-blog__read-more');
let pageIndex = 0;

loadMoreButton.addEventListener('click', function () {
  const start = pageIndex * 5;
  let end = (pageIndex + 1) * 5 -1;
  if (end > blogArticles.length + 5) {
    end = -1;
  }
  const subArray = blogArticles.slice(start, end);

  subArray.forEach(article => {
    var dom = document.createElement('div')
    dom.classList.add('blog-article');
    dom.innerHTML = `
      <div class="blog-article__image-wrapper">
        <img class="blog-article__image" src="${article.image}">
      </div>
      <div class="blog-article__content">
        <div class="blog-article__title tk-linotype-sabon">
          ${article.title}
        </div>
        <div class="blog-article__published-at">
          ${article.published_at}
        </div>
        <div class="blog-article__excerpt">
          ${article.excerpt}
        </div>
        <a class="blog-article__cta" href="${article.url}">
          Read more
          <svg width="11" height="9" viewBox="0 0 11 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M6.14645 0.146453C6.34171 -0.0488175 6.65829 -0.0488175 6.85355 0.146453L10.8536 4.14645C11.0488 4.34171 11.0488 4.65829 10.8536 4.85355L6.85355 8.8536C6.65829 9.0488 6.34171 9.0488 6.14645 8.8536C5.95118 8.6583 5.95118 8.3417 6.14645 8.1464L9.2929 5H0.5C0.22386 5 0 4.77614 0 4.5C0 4.22386 0.22386 4 0.5 4H9.2929L6.14645 0.853552C5.95118 0.658292 5.95118 0.341713 6.14645 0.146453Z" fill="black"/></svg>
        </a>
      </div>
    `;

    document.querySelector('.blog-articles').append(dom);
  });

  pageIndex += 1;
  if ((pageIndex + 1) * 5 - 1 > blogArticles.length + 5) {
    loadMoreButton.classList.add('hidden');
  }
});